export const NO_SPECIAL_CHARS_MSG = 'Cannot contain special characters';
export const EMPTY_FIELD_MSG = 'Placeholder cannot be empty';

export const getDisplayPlaceholderKey = (value, defaultValue, excludePrefix = '') => {
  const rawValue = value ?? defaultValue ?? '';
  if (rawValue && excludePrefix && rawValue.startsWith(excludePrefix)) {
    return rawValue.slice(excludePrefix.length);
  }
  return rawValue;
};

export const hasInvalidPlaceholderKeyChars = (value = '') => /[^a-zA-Z\d\s:_]/.test(value);

export const sanitizePlaceholderKey = (value = '') => value
  .replace(/\s/g, '_')
  .replace(/[^a-zA-Z\d:_]/g, '');

export const formatPlaceholderKey = (value = '', excludePrefix = '') => (
  `${excludePrefix}${sanitizePlaceholderKey(value)}`
);
